import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import _ from 'underscore';
import { FormGroup, Input, Label, Row, Col } from 'reactstrap';
import TextInput from '../../common/controls/textInput';
import { getRuleStyle, isValid } from '../../../utils/passwordRules';
import SecretSetup from '../../common/security/secretSetup';
import { hasPermission } from '../../../utils/paths';
import entityComposition from '../../common/classes/entityComposition';
class EmployeeCredentials extends Component {
  constructor(props) {
    super(props);
    const _this$props = this.props,
      onChange = _this$props.onChange,
      passwordActions = _this$props.passwordActions;
    this.state = {
      hasPassword: false
    };
    this.handleChange = (name, value) => onChange(name, value || null);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handlePasswordFocus = () => passwordActions.resetPasswordRules();
    this.handlePasswordKeyPress = this.handlePasswordKeyPress.bind(this);
  }
  handlePasswordChange(ev) {
    const _this$props2 = this.props,
      onChange = _this$props2.onChange,
      passwordActions = _this$props2.passwordActions;
    const value = ev.target.value;
    if (typeof value === 'string' && ev.key !== 'Enter') {
      passwordActions.checkPasswordRules(value);
      onChange('password', value);
    }
  }
  handlePasswordKeyPress(ev) {
    const onSave = this.props.onSave;
    const value = ev.target.value;
    const password = typeof value === 'string' ? value : '';
    if (ev.key === 'Enter' && isValid(password) && onSave !== null) {
      onSave();
      ev.preventDefault();
    }
  }
  render() {
    const _this$props3 = this.props,
      id = _this$props3.id,
      mfaEnabled = _this$props3.mfaEnabled,
      requireMFA = _this$props3.requireMFA,
      password = _this$props3.password,
      username = _this$props3.username,
      userID = _this$props3.userID,
      customer = _this$props3.customer,
      rules = _this$props3.rules,
      showOnlyPassword = _this$props3.showOnlyPassword;
    // By default, do not show mfa access panel
    let showMFA = false;

    // Show mfa component if the active user is the loaded employee
    // OR if the active user has `user_edit` permissions
    if (typeof id !== 'undefined' && id.length > 0) {
      // Must check to see if this.props.active is present,
      // otherwise may look for id with no data
      showMFA = id === userID || hasPermission('general', 'user_edit');
    }
    // See #120707183: show password mask for any case where a password exists.
    // Can't check the password property itself because we don't send it to the
    // the client.
    const hasPassword = this.state.hasPassword;
    let mfaComponent = null;

    // Build the mfaComponent
    if (showMFA) {
      mfaComponent = /*#__PURE__*/React.createElement(SecretSetup, {
        customer: customer,
        username: username,
        userID: id,
        mfaEnabled: mfaEnabled,
        mfaRequired: requireMFA
      });
    }
    let credInput = null;
    const passwordComponent = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "Password Reset"), /*#__PURE__*/React.createElement("span", null, "Rules:"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
      style: getRuleStyle(rules.length)
    }, "8+ characters without spaces"), /*#__PURE__*/React.createElement("li", {
      style: getRuleStyle(rules.upper)
    }, "At least 1 uppercase"), /*#__PURE__*/React.createElement("li", {
      style: getRuleStyle(rules.lower)
    }, "At least 1 lowercase"), /*#__PURE__*/React.createElement("li", {
      style: getRuleStyle(rules.symbol)
    }, "At least 1 number or symbol")), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "New Password"), /*#__PURE__*/React.createElement(Input, {
      id: "popupModal",
      autoComplete: "off",
      type: "password",
      value: password || '',
      className: "tqc-control"
      /* use unicode, comp exp parses html &#9679; as string */,
      placeholder: hasPassword ? '' : '•••••••••••••••',
      onChange: this.handlePasswordChange,
      onFocus: this.handlePasswordFocus,
      onKeyPress: this.handlePasswordKeyPress
    })));
    if (showOnlyPassword !== true) {
      credInput = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        className: "t-eg-section-credentials"
      }, "TRU Login Credentials"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        sm: 6
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "Username",
        autoComplete: "off",
        field: "username",
        onChange: this.handleChange,
        entity: "User",
        value: username || ''
      }), /*#__PURE__*/React.createElement("br", null), passwordComponent), /*#__PURE__*/React.createElement(Col, {
        sm: 3
      }, mfaComponent)));
    } else {
      // default to JUST show the password component
      credInput = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        sm: 6
      }, passwordComponent)));
    }
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("form", null, credInput));
  }
}
EmployeeCredentials.defaultProps = {
  id: '',
  password: undefined,
  showOnlyPassword: false,
  onSave: null,
  username: '',
  mfaEnabled: false,
  requireMFA: false
};
EmployeeCredentials.propTypes = {
  id: PropTypes.string,
  username: PropTypes.string,
  requireMFA: PropTypes.bool,
  mfaEnabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  password: PropTypes.string,
  showOnlyPassword: PropTypes.bool,
  customer: PropTypes.string.isRequired,
  rules: PropTypes.shape({
    length: PropTypes.bool,
    upper: PropTypes.bool,
    lower: PropTypes.bool,
    symbol: PropTypes.bool
  }).isRequired,
  userID: PropTypes.string.isRequired,
  passwordActions: PropTypes.shape({
    checkPasswordRules: PropTypes.func,
    resetPasswordRules: PropTypes.func
  }).isRequired
};
export { EmployeeCredentials as TestEmployeeCredentials };
export default entityComposition(EmployeeCredentials, [], {
  customer: state => state.login.customer,
  userID: state => state.login.user.user_id,
  rules: state => state.password.rules
}, ['password']);